import React, { useState, useCallback } from "react";
import { Button, Modal, Container, Row, Col, Card } from "react-bootstrap";
import { getOneVisitaService } from "../../utils/VisitasService";
import Loading from "../loading/Loading";

function VerVisitaModal({ id, authTokens }) {
  // States del Modal
  const [show, setShow] = useState(false);
  const [visita, setVisita] = useState();

  // State Loading
  const [loading, setLoading] = useState(true);

  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Funcion encargada de pedir a la db la info de la visita.

  const getVisita = useCallback(async () => {
    const v = await getOneVisitaService(id, authTokens);
    setVisita(v);
    setLoading(false);
  });

  // Funcion que maneja la accion del boton 'Ver'
  const handleOpen = () => {
    handleShow();
    getVisita();
  };

  return (
    <>
      <Button className="m-1" variant="success" size="sm" onClick={handleOpen}>
        Ver
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <Modal.Header closeButton onClick={handleClose}>
              <Modal.Title>Visita #{visita && visita.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid">
              <Container>
                <Row className="mb-4">
                  <Col xs={12} md={3}>
                    <p className="mb-2">Fecha:</p>
                    <h5>{visita && visita.fecha}</h5>
                  </Col>
                  <Col xs={12} md={4}>
                    <p className="mb-2">Cliente:</p>

                    <h5>
                      {visita && visita.nombre}, {visita && visita.apellido}
                    </h5>
                  </Col>
                  <Col xs={12} md={3}>
                    <p className="mb-2">Télefono:</p>
                    <h5>{visita && visita.telefono}</h5>
                  </Col>
                  <Col xs={12} md={2}>
                    <p className="mb-2">Largo Pelo:</p>
                    <h5>{visita && visita.largoPelo}</h5>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <p className="mb-2">Detalle:</p>

                    <h6>{visita && visita.info}</h6>
                  </Col>
                </Row>

                <hr />

                {visita.productos.length !== 0 && (
                  <>
                    <Row className="mb-4">
                      <h5 className="mb-2">Productos Utilizados:</h5>
                      {visita &&
                        visita.productos.map((producto, index) => {
                          return (
                            <Col key={index} xs={12} md={6}>
                              <Card style={{ padding: "10px" ,marginBottom:"15px"}}>
                                Producto: <h5>{producto.producto}</h5>
                                Marca: <h5>{producto.marca}</h5>
                                Precio: <h5>${producto.precio}</h5>
                              </Card>
                            </Col>
                          );
                        })}
                      <br />
                      <h5 className="mt-4 text-info">
                        Total Productos: ${visita && visita.totalProductos}
                      </h5>
                    </Row>

                    <hr />
                  </>
                )}

                {visita.servicios.length !== 0 && (
                  <>
                    <Row className="mb-4">
                      <h5 className="mb-2">Servicios Utilizados:</h5>

                      {visita &&
                        visita.servicios.map((servicio, index) => {
                          return (
                            <Col
                              key={index}
                              xs={12}
                              md={6}
                            >
                              <Card style={{ padding: "10px" ,marginBottom:"15px"}}>
                                Servicio: <h5>{servicio.servicio}</h5>
                                Precio: <h5>${servicio.precio}</h5>
                              </Card>
                            </Col>
                          );
                        })}
                      <br />
                      <h5 className="mt-4 text-info">
                        Total Servicios: ${visita && visita.totalServicios}
                      </h5>
                    </Row>

                    <hr />
                  </>
                )}

                <Row>
                  <Col xs={12} md={6}>
                    {visita && visita.formaDePago === "Debe" ? (
                      <h5 className="mt-4 text-danger">
                        Total a Cobrar $
                        {visita &&
                          visita.totalServicios + visita.totalProductos}
                      </h5>
                    ) : (
                      <h5 className="mt-4 text-success">
                        Total Cobrado $
                        {visita &&
                          visita.totalServicios + visita.totalProductos}
                      </h5>
                    )}
                  </Col>
                  <Col xs={12} md={6}>
                    <p>Forma de pago:</p>
                    <h5>{visita && visita.formaDePago}</h5>
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => handleClose()} variant="info" size="sm">
                Cerrar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
}

export default VerVisitaModal;
